import { Map } from 'immutable';
export default Map({
  smallHits: Map({
    xl: 4,
    lg: 4,
    md: 4,
    sm: 12,
    xs: 12
  })
});